import script from "./EcommerceLegalBases.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceLegalBases.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceLegalBases.vue?vue&type=style&index=0&id=854828e8&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-854828e8"]])

export default __exports__